import React from "react";
import { getNodeAnimation } from "./../../../../_shared/node-animation/get-node-animation.js";
import { hasEntranceAnimation } from "./../../../../_shared/node-animation/has-entrance-animation.js";
const SELF_ANIMATED_TYPES = /* @__PURE__ */ new Set(["LIST_ITEM"]);
const AnimationDecorator = {
  rule: (node) => Boolean(getNodeAnimation(node)) && !SELF_ANIMATED_TYPES.has(node.type),
  decorate: ({ node, element }) => /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-ricos-animation": node.id,
      ...hasEntranceAnimation(getNodeAnimation(node)) ? { "data-ricos-entrance": "" } : {}
    },
    element
  )
};
export {
  AnimationDecorator
};
//# sourceMappingURL=animation-decorator.js.map
